import React from "react";
import { Loader2 } from "lucide-react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl sm:text-[28px] font-heading font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}

export function SectionHeader({ children, right }) {
  return (
    <div className="flex items-center justify-between mt-8 mb-3">
      <h2 className="text-xs font-bold uppercase tracking-widest text-slate-500">{children}</h2>
      {right}
    </div>
  );
}

export function Spinner({ className = "" }) {
  return <div className={`flex items-center justify-center py-16 ${className}`}><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="text-center py-16 bg-white rounded-xl border border-dashed border-slate-300">
      {Icon && <Icon className="h-10 w-10 mx-auto text-slate-300" />}
      <div className="mt-3 font-semibold text-slate-700">{title}</div>
      {subtitle && <div className="text-sm text-slate-400 mt-1 max-w-sm mx-auto">{subtitle}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
